// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';
import { CardTypes, RunningLabStatus, RunningChallengeStatus, RunningExamStatus } from '../../../types/Model';

export interface GetHomeRequestPayload {
}
export interface GetHomeSuccessPayload {
  list: IProduct[];
}

export interface GetHomeFailPayload {
  error: string;
}

export const getHomeActions = createAsyncAction(
  'elearning/GET_HOME',
  'elearning/GET_HOME_SUCCESS',
  'elearning/GET_HOME_FAIL'
)<GetHomeRequestPayload, GetHomeSuccessPayload, GetHomeFailPayload>();

interface OnlineCourseProductFragment {
  type: CardTypes.COURSE;
  vodCount: number;
  labCount: number;
  challengeCount: number;
  assessmentCount: number;
  examCount: number;
  examTotalCount: number;
  completionProgress: number;
  completionTime: Date | null;
  latestTime: Date | null;
}

interface LabProductFragment {
  type: CardTypes.LAB;
  status: RunningLabStatus;
  completionTime: Date;
}

interface ChallengeProductFragment {
  type: CardTypes.CHALLENGE;
  status: RunningChallengeStatus;
  completionTime: Date;
}

interface ExamProductFragment {
  type: CardTypes.EXAM;
  examCount: number;
  examTotalCount: number;
  completionTime: Date;
  status: RunningExamStatus;
}

interface WorkshopProductFragment {
  type: CardTypes.WORKSHOP;
  vodCount: number;
  labCount: number;
  challengeCount: number;
  assessmentCount: number;
  examCount: number;
  examTotalCount: number;
  startTime: Date;
  endTime: Date;
  latestTime: Date | null;
  completionProgress: number;
  completionTime: Date | null;
}
interface Product {
  id: number;
  name: string;
  platformId: number;
  domainIds: number[];
  totalDuration: number;
  levelId: number;
  language: string;
  imageUrl: string;
}

export type IProduct = Product & (OnlineCourseProductFragment | ChallengeProductFragment | LabProductFragment | WorkshopProductFragment);
